import { memoizeReduxStateForMultipleIds } from '@range.io/functional'
import memoizeResult from '../../memoize-result.js'
import { _field } from '../../selector-primitives.js'

const updatesAsArray = memoizeResult(state => Object.values(state.updates))

const _updatesForCollaborationId = (state, id) => Object.values(state.updates).filter(u => u.collaborationId === id)
const updatesForCollaborationId = memoizeReduxStateForMultipleIds(['updates'], _updatesForCollaborationId)

/*
 * All the Updates for the selected Collaboration
 * @sig updatesForSelectedCollaboration :: State -> [Update]
 */
const updatesForSelectedCollaboration = state => {
    const { selectedCollaborationId } = state

    // no Collaboration selected, implies there are no selected Updates either
    return selectedCollaborationId ? updatesForCollaborationId(state, selectedCollaborationId) : []
}

// ---------------------------------------------------------------------------------------------------------------------
// API
// ---------------------------------------------------------------------------------------------------------------------

const UpdateSelectors = {
    updatesAsArray,
    updatesForCollaborationId,
    updatesForSelectedCollaboration,
    updatesAsPOJO: _field('updates'),
}

export default UpdateSelectors
